import React from 'react';

export default class Page1 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">


                                <div className="ilead-rgt task">
                                    <div className="innerpadding">
                                        <div className="innovativeimg">
                                            <img alt=""
                                                 src={require('@images/Howt_to_take_responsibility.png')}/>
                                        </div>

                                        <div className="ilead-contentarea">

                                            <div className="circle_title"><img
                                                src={require('@images/Browndot.png')}
                                                alt=""/>isn't it interesting?
                                            </div>
                                            <p>What would you do in an emergency?</p>


                                            <div className="border_subtitle">Calm in an emergency?</div>
                                            <div className="paraspace"><p>Everybody likes to think that they
                                                would keep a calm head in a crisis, help another in a time of
                                                need or at least call the police in an emergency. However,
                                                research into a phenomenon known as
                                                the ‘bystander effect’ may suggest otherwise.<a
                                                    className="superscripttext"
                                                    href="furtherinfo.php?course=300"><sup>1</sup></a> When
                                                others are present, observers can assume
                                                that someone else will intervene, and so they each individually
                                                refrain from doing so; in effect we
                                                feel less responsible. People may also assume that other
                                                bystanders are more qualified to help,
                                                such as doctors or police officers, and their intervention would
                                                thus be unnecessary or even
                                                unwanted. This can be due to a fear of losing ‘face’ in front of
                                                others or being superseded by a
                                                better helper.</p></div>

                                            <div className="lightgreencontentbg keyquestionpad ">
                                                <div className="border_subtitle">‘Using your loaf’</div>
                                                <p>Before the discovery of the ‘bystander effect’ there was an
                                                    investigation into a similar
                                                    effect which occurred in the structure of work. What was
                                                    discovered is a phenomenon
                                                    commonly referred to as ‘social loafing’.<a
                                                        className="superscripttext"
                                                        href="furtherinfo.php?course=300"><sup>2</sup></a>
                                                    This is where a group of individuals working on a
                                                    task together will personally contribute less effort than if
                                                    they were working on their own.
                                                    This is a subtle effect and was first shown in a simple
                                                    rope-pulling exercise, where
                                                    individuals exerted less energy pulling the rope as part of
                                                    a group than as an individual.<a className="superscripttext"
                                                                                     href="furtherinfo.php?course=300"><sup>3</sup></a>
                                                </p>

                                                <div className="uiheading"><p> There are ways to prevent
                                                yourself and others from being a ‘loafer’, such as recording
                                                individual work, assigning specific roles, and increasing
                                                communication and collaboration
                                                within the team. Often, the most common reason for loafing
                                                is feeling that any effort will
                                                not be utilised or recognised, so a sense of personal
                                                responsibility can be critical to our
                                                overall effectiveness in work.</p>
                                            </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page2')}
                                                    className="button-next-previous-done task">Next &gt;&gt;</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}